export const enum StationVisibilityOptions {
  ALL = 'all',
  VISIBLE = 'visible',
}

export const enum OrderStatusTags {
  IN_PROGRESS = 'in_progress',
  READY = 'ready',
  YESTERDAY = 'yesterday',
  TODAY = 'today',
}
